import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children", "tooltipProps"];
import { Box, Text, TextButton, Tooltip } from '@wix/design-system';
import React from 'react';
import { DomainSearchSuiteModule } from '../../../../../domainSearchSuite.module';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainNameError } from './DomainNameError';
import { parseDomain } from '@wix/domains-serverless-interface';
import { useIsMobile } from '@wix/core-domain-search';
import { ModalsModule } from '../../../../ModalsExtensions';
import { ExperimentSpecs } from '../../../../../../constants';
export const InvalidDomain = _ref => {
  var _getPremiumEssentials;
  let domainName = _ref.domainName;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans;
  const isMobile = useIsMobile();
  const _parseDomain = parseDomain(domainName ?? ''),
    tld = _parseDomain.tld,
    formattedInput = _parseDomain.formattedInput;
  const showModal = !!((_getPremiumEssentials = getPremiumEssentialsSafe()) != null && (_getPremiumEssentials = _getPremiumEssentials.experiments) != null && _getPremiumEssentials[ExperimentSpecs.AvailableTldsModal]);
  return /*#__PURE__*/React.createElement(DomainNameError, null, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.unavailable_domain",
    values: {
      domainName: formattedInput,
      tld: `.${tld}`
    },
    components: [isMobile || showModal ? /*#__PURE__*/React.createElement(DomainTldsTextButtonWithModal, null) : /*#__PURE__*/React.createElement(DomainTldsTextButtonWithTooltip, null)]
  })));
};
const DomainTldsTextButtonWithModal = _ref2 => {
  var _getPremiumEssentials2;
  let children = _ref2.children;
  const availableExtensionsModal = ModalsModule.internals.domainsSharedModalsController.availableExtensionsModal;
  const tldsListModalEnabled = !!((_getPremiumEssentials2 = getPremiumEssentialsSafe()) != null && (_getPremiumEssentials2 = _getPremiumEssentials2.experiments) != null && _getPremiumEssentials2[ExperimentSpecs.LoggedInMobileGate]);
  return /*#__PURE__*/React.createElement(Box, {
    inline: true
  }, /*#__PURE__*/React.createElement(TextButton, {
    dataHook: "available-extensions-trigger",
    size: "small",
    weight: "thin",
    onClick: () => availableExtensionsModal.show(tldsListModalEnabled ? {
      variant: 'list'
    } : {})
  }, children));
};
const DomainTldsTextButtonWithTooltip = _ref3 => {
  let children = _ref3.children,
    tooltipProps = _ref3.tooltipProps,
    buttonProps = _objectWithoutPropertiesLoose(_ref3, _excluded);
  const _DomainSearchSuiteMod2 = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod2.t;
  return /*#__PURE__*/React.createElement(Box, {
    inline: true
  }, /*#__PURE__*/React.createElement(Tooltip, _extends({
    maxWidth: "480px"
  }, tooltipProps, {
    content: /*#__PURE__*/React.createElement(Box, {
      padding: "SP1 SP2 SP1 SP2",
      direction: "vertical",
      gap: "SP3"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "bold",
      light: true
    }, t('domain_search_suite.error.unavailable_domain.tooltip.available_extensions')), /*#__PURE__*/React.createElement(DomainTldsTooltipContent, null))
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TextButton, _extends({
    size: "small",
    weight: "thin"
  }, buttonProps), children))));
};
const DomainTldsTooltipContent = () => {
  var _supportedTldsState$d;
  const supportedTldsState = DomainsApiClient.hooks.useDomainTlds({});
  return /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(90px, 1fr))"
  }, ((_supportedTldsState$d = supportedTldsState.data) == null ? void 0 : _supportedTldsState$d.tlds.map(_ref4 => {
    let tld = _ref4.tld;
    return /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      key: tld,
      light: true
    }, ".", tld);
  })) ?? []);
};
//# sourceMappingURL=InvalidDomain.js.map